/**
 * Job Translations Module
 */
import { jobPt } from './pt'
import { jobEn } from './en'

export const job = {
  pt: jobPt,
  en: jobEn,
}
